import React from 'react';
import { inject, observer } from 'mobx-react';
import WorkflowStepBaseComponent from '../workflow-step-base';
import _ from 'lodash';
import StepHistory from '../../../components/step-history';
import * as moment from 'moment';
import Notfication from '../../../utils/notification-helper';
import Cons from '../../../../isomorphic/cons';
import PropTypes from 'prop-types';
import StepActionButtons from '../components/step-actions';
import WorkflowStepTransitionModel from '../../workflow-step-transition-model';
import StepSendEmail from '../components/step-send-email';

@inject('appStore')
@observer
export default class SimpleEmailAuditStep extends WorkflowStepBaseComponent {
    constructor(props) {
        super(props);
        this.state = { showEmail: false };
    }

    onSent(email) {
        this.setState({ showEmail: false });
        const step = this.props.step;
        delete step.state.data.drafts;
        delete step.state.data.templateId;
        step.state.data.emails = step.state.data.emails ? step.state.data.emails.concat([email]) : [email];
        return this.updateStepState(step);
    }

    handleCheckedChange() {
        const step = this.props.step;
        step.state.isComplete = !step.state.isComplete;
        if (step.state.isComplete) {
            const transition = new WorkflowStepTransitionModel();
            transition.status = Cons.transitionTypes.Active;
            transition.createdOn = moment().format();
            transition.reasons.push('Step completed');
            step.state.transitions.push(transition);
        }

        this.setState({ showEmail: false });
        this.updateStepState(step);
    }

    renderCompleteView() {
        return this.renderView(true);
    }

    renderIncompleteView() {
        return this.renderView(false);
    }

    showEmail(value, evt) {
        evt.preventDefault();
        this.setState({ showEmail: value });
    }

    renderView(isComplete) {
        const template = this.props.options.templateTag,
            stepDisabled = this.props.step.state.latestTransition
                ? this.props.step.state.latestTransition.status === Cons.transitionTypes.NotApplicable
                : false;
        const hasCancelButton = true

        return (
            <div className={`${this.props.className}`}>
                <form key={`${this.props.className}`}>
                    <div className="col-xs-12 col-sm-12 checkbox-group">
                        <div className="form-group">
                            <div className={`checkbox ${stepDisabled ? 'disabled' : ''}`}>
                                <label>
                                    <input
                                        type="checkbox"
                                        checked={isComplete}
                                        disabled={stepDisabled}
                                        onChange={this.handleCheckedChange.bind(this)}
                                    />
                                    {this.props.options.question}
                                </label>
                            </div>
                        </div>
                    </div>
                </form>
                <div className="row">
                    <div className="col-sm-6">
                        <StepActionButtons
                            hideNaAction={this.props.hideNaAction}
                            hideWaitingAction={this.props.hideWaitingAction}
                            viewStore={this.viewStore}
                            step={this.props.step}
                        />
                    </div>
                    <div className="col-sm-6">
                        <button
                            className="btn btn-default pull-right"
                            disabled={isComplete || this.state.showEmail || stepDisabled}
                            onClick={this.showEmail.bind(this, true)}
                        >
                            Send Email Reminder
                        </button>
                    </div>
                </div>

                <hr className="section-header" />
                <div className={'col-md-12'}>
                    {!isComplete && this.state.showEmail ? (
                        <StepSendEmail
                            step={this.props.step}
                            updateStepState={this.updateStepState.bind(this)}
                            typeOfSale={this.props.appStore.tcFileStore.selectedFile.typeOfSale}
                            template={template}
                            contacts={this.state.contacts}
                            extraTemplateData={Object.assign(
                                {
                                    agent: this.props.appStore.tcFileStore.selectedFileContacts.find(
                                        (agent) => agent.contactTypeId === Cons.prime.fileContactType.FileAgent
                                    ),
                                    day: this.props.deadlineCalculated,
                                },
                                this.props.options.extraTemplateData
                            )}
                            onSent={this.onSent.bind(this)}
                            cancelHandler={this.showEmail.bind(this, false)}
                            hasCancelHandler={hasCancelButton}
                        />
                    ) : null}
                </div>
                <div className={'col-md-12'}>
                    <StepHistory
                        transitions={this.props.step.state.transitions ? this.props.step.state.transitions : []}
                        emails={this.props.step.state.data.emails ? this.props.step.state.data.emails : []}
                    />
                </div>
            </div>
        );
    }
}

SimpleEmailAuditStep.propTypes = {};



// WEBPACK FOOTER //
// ./src/workflow/steps/audit/simple-email-audit-step.js